<template>
  <div>
    <basic-container>
      <div>
        <el-form :model="goodsForm">
          <el-form-item label="产品名称" style="display: flex; width: 300px;">
            <el-input v-model="goodsForm.name" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
          <!-- 产品价格 -->
          <el-form-item label="产品价格" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.price" placeholder="请输入产品价格" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="返利金额" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.rebate" placeholder="请输入返利金额" clearable></el-input>
          </el-form-item>
          <el-form-item label="推广费用" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.laborCost" placeholder="请输入推广费" clearable></el-input>
          </el-form-item>
          <el-form-item label="换新提醒配置">
            <el-table :data="goodsFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="name" label="显示名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="请输入名称" clearable></el-input>
                </template>
</el-table-column>
<el-table-column prop="time" label="到期时间" min-width="150">
  <template slot-scope="scope">
                  <div style="display: flex; align-items: center;">
                    <el-input v-model.number="scope.row.time" placeholder="请输入到期时间" type="number" min="1"
                      clearable></el-input>
                    <el-select v-model="scope.row.unit" placeholder="请选择时间单位" clearable style="margin-right: 10px;">
                      <el-option v-for="unit in units" :key="unit.value" :label="unit.valueName"
                        :value="unit.value"></el-option>
                    </el-select>
                  </div>
                </template>
</el-table-column>
<el-table-column align="center" label="操作" width="150">
  <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete(scope.$index)">删除</el-button>
                </template>
</el-table-column>
<el-table-column align="center" label="配置" width="150">
  <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-plus" size="small"
                    @click="handleAddRows(scope.$index)">增加一行</el-button>
                </template>
</el-table-column>
</el-table>
          </el-form-item> -->
        </el-form>
        <!-- <el-form :model="dynamicForm">
          <el-form-item label="动态表单配置">
            <el-table :data="dynamicFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="fieldName" label="显示名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.fieldName" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="inputType" label="控件类型" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.inputType" placeholder="请选择控件类型" clearable>
                    <el-option v-for="inputType in inputTypes" :key="inputType.id" :label="inputType.name"
                      :value="inputType.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="dataSource" label="数据源" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.dataSource" placeholder="请选择数据源" clearable>
                    <el-option v-for="dataSource in dataSources" :key="dataSource.id" :label="dataSource.valueName"
                      :value="dataSource.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="isNull" label="是否为空" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.isNull">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="sort" label="排序" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sort"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete1(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-plus" size="small"
                    @click="handleAddRows1(scope.$index)">增加一行</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form> -->
      </div>
      <div style="width: 100%; display: flex; flex-flow: row nowrap; justify-content: center; margin-top: 20px">
        <!-- 返回上一页 -->
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        <el-button type="primary" size="small" @click="submit" icon="el-icon-circle-check-outline">确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { updateGoods, getGoodsForm } from "@/api/work/waterProof/purWaterGoods";
import { DIC } from "@/const/dic";
// import { findDataSourceFields, findDataSourceAll } from "@/api/work/dynamicForm";
export default {
  data() {
    return {
      units: [
        { value: 'DAY', valueName: '天' },
        { value: 'MOON', valueName: '月' },
        { value: 'YEAR', valueName: '年' },
      ],
      goodsForm: {
        name: '',
        id: '', // 添加id字段，用于提交时区分是新增还是修改
        filters: [] // 存放从接口获取的原始数据
      },
      goodsFormData: [], // 用于编辑的临时数据
      formData: '',
      isPas: false,
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      dynamicForm: {
        formName: '',
        formType: ''
      },
      dynamicTypes: [], // 确保这是一个数组
      dynamicFormData: [] // 确保这是一个数组
    };
  },
  created() {
    /* findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    }); */
    const goodsId = this.$route.query.GoodsId; // 假设产品ID通过路由参数传递
    if (goodsId) {
      this.fetchGoodsData(goodsId);
    }
    /* else {
      // 初始化时如果数据为空，添加一行默认数据
      if (this.goodsFormData.length === 0) {
        this.goodsFormData.push({
          name: '',
          time: '',
          unit: '',
        });
      }
      if (this.dynamicFormData.length === 0) {
        this.dynamicFormData.push({
          fieldName: '',
          inputType: '',
          dataSource: '',
          isNull: '',
          sort: ''
        });
      }
    } */
  },
  methods: {
    fetchGoodsData(goodsId) {
      getGoodsForm(goodsId).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.goodsForm = data;
          console.log('data::: ', data);
          /* this.goodsFormData = data.filters.map(filter => ({ ...filter }));
          this.dynamicFormData = data.dynamicFormRequest.fields.map(field => ({
            id: field.id,
            dynamicId: field.dynamicId,
            deleteFlag: field.deleteFlag,
            createBy: field.createBy,
            createTime: field.createTime,
            updateBy: field.updateBy,
            updateTime: field.updateTime,
            fieldName: field.fieldName,
            inputType: this.formatInputType(field.inputType),
            dataSource: field.dataSource,
            isNull: field.isNull,
            sort: field.sort
          }));
          // 如果加载后的数据为空，添加一行默认数据
          if (this.goodsFormData.length === 0) {
            this.goodsFormData.push({
              name: '',
              time: '',
              unit: '',
            });
          }
          if (this.dynamicFormData.length === 0) {
            this.dynamicFormData.push({
              fieldName: '',
              inputType: '',
              dataSource: '',
              isNull: '',
              sort: ''
            });
          } */
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    // 格式化inputType
    formatInputType(inputType) {
      // 将 inputType 转换为字符串类型
      const inputTypeString = String(inputType); // 使用 String 而不是 toString
      const matchedType = this.inputTypes.find(item => item.id == inputTypeString);
      return matchedType ? matchedType.name : ''; // 添加检查以防止未找到匹配项
    },
    goBack() {
      let item = {
        close: true,
        label: "编辑净水产品",
        value: "/work/waterProject/purWaterGoods/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    submit() {
      const submitData = {
        ...this.goodsForm,
        /* filters: this.goodsFormData,
        dynamicFormRequest: {
          id: this.goodsForm.dynamicFormRequest.id || '', // 如果有 ID 则更新，否则添加
          name: this.goodsForm.dynamicFormRequest.formName,
          rootDepartId: this.goodsForm.dynamicFormRequest.rootDepartId || '', // 根据实际情况设置
          deleteFlag: this.goodsForm.dynamicFormRequest.deleteFlag || '', // 这个字段根据实际情况设置
          createBy: this.goodsForm.dynamicFormRequest.createBy || '', // 这个字段根据实际情况设置
          createTime: this.goodsForm.dynamicFormRequest.updateTime, // 使用当前时间戳
          updateBy: this.goodsForm.dynamicFormRequest.updateBy || null, // 根据实际情况设置
          updateTime: this.goodsForm.dynamicFormRequest.updateTime || null, // 根据实际情况设置
          fields: this.dynamicFormData.map(field => ({
            id: field.id || '', // 如果有 ID 则更新，否则添加
            dynamicId: field.dynamicId || '', // 根据实际情况设置
            fieldName: field.fieldName,
            inputType: this.inputTypes.find(inputType => inputType.name == field.inputType || inputType.id == field.inputType).id,
            dataSource: field.dataSource || '', // 根据实际情况设置
            isNull: field.isNull,
            sort: field.sort || '', // 根据实际情况设置
            deleteFlag: field.deleteFlag || '', // 这个字段根据实际情况设置
            createBy: field.createBy || '', // 这个字段根据实际情况设置
            createTime: field.updateTime, // 使用当前时间戳
            updateBy: field.updateBy || null, // 根据实际情况设置
            updateTime: field.updateTime || null // 根据实际情况设置
          }))
        } */
      };
      updateGoods(submitData).then(res => {
        if (res.code === "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.$store.commit('DEL_ALL_TAG')
          // 返回上一页
          this.$router.go(-1);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleSteppingDelete(index) {
      if (this.goodsFormData.length === 1) {
        this.$message({
          showClose: true,
          message: "动态产品不能为空",
          type: "error"
        });
      } else {
        this.goodsFormData.splice(index, 1);
      }
    },
    handleAddRows() {
      this.goodsFormData.push({
        name: '',
        time: '',
        unit: '',
      });
    },
    handleSteppingDelete1(index) {
      if (this.dynamicFormData.length == 1) {
        this.$message({
          showClose: true,
          message: "动态表单配置不能为空",
          type: "error"
        });
      } else {
        this.dynamicFormData.splice(index, 1);
      }
    },
    handleAddRows1() {
      this.dynamicFormData.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        sort: ''
      });
    }
  }
};
</script>

<style scoped></style>
